/** Upcoming webinars & events - Eventbrite registration links open in a new tab. */
export const WEBINAR_EVENTS = [
  {
    id: 'workplace-journeys',
    title: 'Assume We Can: Reimagining Workplace Journeys',
    description:
      'An interactive workshop exploring how workplace expectations, evaluation norms, and informal leadership criteria shape what becomes possible for South Asian women in STEMM.',
    schedule: null,
    format: 'Online',
    duration: '1 hour',
    organizer: 'Lotus STEMM & Campfire Kinship',
    href: 'https://www.eventbrite.ca/e/assume-we-can-reimagining-workplace-journeys-tickets-1990641283666',
  },
  {
    id: 'family-support-stemm',
    title: 'Assume We Can: Reimagining Family Support for South Asian Women in STEMM',
    description:
      'A reflective workshop for parents and guardians on how family, community, education, and workplace experiences shape South Asian women\'s journeys in STEMM - using story-based learning and meta-reflexive practice.',
    schedule: 'Wednesday, August 5 • 6:00-7:00 PM EDT',
    format: 'Online',
    duration: '1 hour',
    organizer: 'Lotus STEMM & Campfire Kinship',
    href: 'https://www.eventbrite.ca/e/assume-we-can-reimagining-family-support-for-south-asian-women-in-stemm-tickets-1992525357983?aff=oddtdtcreator',
  },
  {
    id: 'community-support-stemm',
    title: 'Assume We Can: Reimagining Community Support for South Asian Women in STEMM',
    description:
      'An interactive, in-person community workshop exploring how community spaces can reinforce barriers or become places of encouragement, connection, and opportunity for South Asian women in STEMM.',
    schedule: 'Saturday, September 12 • 9:30-11:00 AM (277 Strathcona Rd SW, Calgary, AB)',
    format: 'In person',
    duration: '1 hour 30 minutes',
    organizer: 'Lotus STEMM & Campfire Kinship',
    href: 'https://www.eventbrite.ca/e/assume-we-can-reimagining-community-support-for-south-asian-women-in-stemm-tickets-1993747788305?aff=erelpanelorg',
  },
];
